import { IonButton, IonCheckbox, IonContent, IonGrid, IonLoading, IonPage, IonRow, IonSearchbar, useIonAlert } from "@ionic/react";
import HeadFoot from "../Head";
import AdminHead from "./adminHead";
import Sidebar from "./sidebar";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import "./report.css";
import UserService from "../../Services/auth.service";
import Authservice from "../../Services/user.service";
import { AppContext } from "../../components/AppContext";
import CommonDataTable from "../../components/datatable";
import DataTable from "react-data-table-component";
import CommonModal from "../../components/popipInfo";
 
type RowType = {
    BookingOrderNumber: string;
    FirstName?: string;
    TotalAmount?: string;
    DisbursementNumber?: string;
    FundRef1?: string;
    FundRef2?: string;
    PaymentOrderNo?: string;
    SrlNo?: string;
    FundCategory?: string;
    PoojaCode?: string;
    FundId?: string;
    BookingDetailNumber?: string;
    details?: any[];
    // Add editable fields and selection state directly to row
    editablePaymentOrderNo?: string;
    editableFundRef1?: string;
    editableFundRef2?: string;
    isSelected?: boolean;
};
 
const FundDisbursed: React.FC = () => {
    const userRole = sessionStorage.getItem("UserData");
    const [usertoken, setUsertoken] = useState(sessionStorage.getItem("token"));
    const [userId]: any = useState(sessionStorage.getItem("UserId"));
 
    const [Alert] = useIonAlert();
    const [showLoading, setShowLoading] = useState(false);
    const [reportData, setReportData] = useState<RowType[]>([]);
    const [filterText, setFilterText] = useState("");
    const { exportCSV } = useContext(AppContext)!;
 
    // Keep only filteredData - this will contain everything
    const [filteredData, setFilteredData] = useState<RowType[]>([]);
   
    // Removed these states as per TL's instruction:
    // const [selectedRows, setSelectedRows] = useState<RowType[]>([]);
    // const [selectedRowIds, setSelectedRowIds] = useState<string[]>([]);
    // const [editableFields, setEditableFields] = useState<Record<string, any>>({});
   
    const [confirmed, setConfirmed] = useState(false);
    const [actualData, setActualData] = useState<RowType[]>([]);
    const [Commonmodal, setCommonmodal] = useState(false);
    const [CommonModalMesg, setCommonModalMesg] = useState("");
    const [Commmonmodaltitle, setCommonmodaltitle] = useState("");
    const [expandedRows, setExpandedRows] = useState<Record<string, boolean>>({});
 
    // Get selected rows from filteredData
    const selectedRows = useMemo(() => {
        return filteredData.filter(row => row.isSelected);
    }, [filteredData]);
 
    // Get selected row IDs from filteredData
    const selectedRowIds = useMemo(() => {
        return filteredData.filter(row => row.isSelected).map(row => row.BookingOrderNumber);
    }, [filteredData]);
 
    // Input field styling
    const inputStyle = {
        width: '100%',
        padding: '8px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        backgroundColor: '#fff',
        color: '#000',
        transition: 'border-color 0.2s ease-in-out'
    };
 
    // Update editable field in filteredData
    const handleInputChange = useCallback((bookingOrderNumber: string, field: string, value: string) => {
        setFilteredData(prev => prev.map(row => {
            if (row.BookingOrderNumber === bookingOrderNumber) {
                return {
                    ...row,
                    [`editable${field}`]: value
                };
            }
            return row;
        }));
    }, []);
 
    // Optimized Input Component
    const OptimizedInput = useCallback(({ value, bookingOrderNumber, field }: {
        value: string,
        bookingOrderNumber: string,
        field: string
    }) => (
        <input
            type="text"
            value={value}
            onChange={(e) => handleInputChange(bookingOrderNumber, field, e.target.value)}
            style={inputStyle}
            onFocus={(e) => e.target.style.borderColor = '#007bff'}
            onBlur={(e) => e.target.style.borderColor = '#ccc'}
        />
    ), [handleInputChange]);
 
    useEffect(() => {
        setShowLoading(true);
        const getCurrentDateTime = () => {
            const now = new Date();
            return now.getFullYear() +
                '-' + String(now.getMonth() + 1).padStart(2, '0') +
                '-' + String(now.getDate()).padStart(2, '0') +
                ' ' + String(now.getHours()).padStart(2, '0') +
                ':' + String(now.getMinutes()).padStart(2, '0') +
                ':' + String(now.getSeconds()).padStart(2, '0');
        };
 
        const date = getCurrentDateTime();
        UserService.getFundDisbursed(usertoken, userId, date).then((response: any) => {
            if (response.status === 200) {
                setActualData(response.data);
                const data = response.data.reduce((acc: any, row: any) => {
                    if (row.SrlNo === "1") {
                        acc.push({
                            ...row,
                            details: [],
                            // Initialize editable fields and selection state
                            editablePaymentOrderNo: row.PaymentOrderNo || "",
                            editableFundRef1: row.FundRef1 || "",
                            editableFundRef2: row.FundRef2 || "",
                            isSelected: false
                        });
                    } else {
                        const parent = acc.find((header: any) => header.BookingOrderNumber === row.BookingOrderNumber);
                        if (parent) {
                            parent.details.push(row);
                        }
                    }
                    return acc;
                }, []);
 
                setReportData(data);
                setFilteredData(data); // Initialize filteredData with all data
                setShowLoading(false);
            }
        }).catch((error: any) => {
            setShowLoading(false);
            console.error("Error fetching fund disbursed data:", error);
        });
    }, [usertoken, userId]);
 
    // Update filteredData when confirmed state changes
    useEffect(() => {
        if (confirmed) {
            // Show only selected rows
            setFilteredData(prev => prev.filter(row => row.isSelected));
        } else {
            // Show all rows from reportData with current editable values preserved
            setFilteredData(prev => {
                // Create a map of current editable values and selection states
                const currentEditableValues = new Map();
                prev.forEach(row => {
                    currentEditableValues.set(row.BookingOrderNumber, {
                        editablePaymentOrderNo: row.editablePaymentOrderNo,
                        editableFundRef1: row.editableFundRef1,
                        editableFundRef2: row.editableFundRef2,
                        isSelected: row.isSelected
                    });
                });
 
                // Return all reportData with preserved editable values
                return reportData.map(row => {
                    const savedValues = currentEditableValues.get(row.BookingOrderNumber);
                    return {
                        ...row,
                        editablePaymentOrderNo: savedValues?.editablePaymentOrderNo ?? row.PaymentOrderNo ?? "",
                        editableFundRef1: savedValues?.editableFundRef1 ?? row.FundRef1 ?? "",
                        editableFundRef2: savedValues?.editableFundRef2 ?? row.FundRef2 ?? "",
                        isSelected: savedValues?.isSelected ?? false
                    };
                });
            });
        }
    }, [confirmed, reportData]);
 
    // Apply search filter to filteredData
    const tableData = useMemo(() => {
        return filteredData.filter(
            (item: any) =>
                JSON.stringify(item)
                    .toLowerCase()
                    .indexOf(filterText.toLowerCase()) !== -1
        );
    }, [filteredData, filterText]);
 
    const modalClose = () => {
        setCommonmodal(false);
    };
 
    // Handle row selection - update filteredData
    const handlingRowSelect = (row: RowType) => {
        setFilteredData(prev => prev.map(item => {
            if (item.BookingOrderNumber === row.BookingOrderNumber) {
                return {
                    ...item,
                    isSelected: !item.isSelected
                };
            }
            return item;
        }));
    };
 
    const handleSubmit = async () => {
        if (selectedRows.length === 0) {
            Alert({
                header: "Atmagram",
                message: "Please select at least one row to process.",
                buttons: ["OK"]
            });
            return;
        }
 
        console.log("Selected rows for submission:", selectedRows);
        setShowLoading(true);
 
        try {
            // Prepare batch data using selectedRows from filteredData
            const batchData = selectedRows.map(selectedRow => ({
                bookingOrderNo: selectedRow.BookingOrderNumber,
                fundRef1: selectedRow.editableFundRef1 || "",
                fundRef2: selectedRow.editableFundRef2 || "",
                paymentOrderNo: selectedRow.editablePaymentOrderNo || ""
            }));
 
            console.log("Submitting batch data:", batchData);
 
            // Single API call for all selected rows
            const response = await Authservice.updateFundForDisbursed(
                usertoken,
                userId,
                usertoken,
                batchData
            );
 
            if (!response || response.status !== 200) {
                console.error("Batch API Error");
                console.error("API response status:", response?.status);
                console.error("API response data:", response?.data);
 
                const error = new Error(`Failed to update batch disbursement`);
                (error as any).response = response;
                throw error;
            }
 
            console.log("Batch API response status:", response.status);
 
            // Success
            setShowLoading(false);
            setCommonModalMesg("Disbursement Details are updated successfully.");
            setCommonmodaltitle("Information");
            setCommonmodal(true);
            window.location.reload();
 
        } catch (error: any) {
            setShowLoading(false);
            console.log("Caught error:", error);
            console.log("Error response:", error.response);
 
            let errorMessage = "Failed to update disbursement details. Please try again.";
 
            if (error.response) {
                const status = error.response.status;
                const message = error.response.data?.message;
 
                if (status === 409) {
                    errorMessage = message || "Conflict: The data was modified elsewhere.";
                } else if (message) {
                    errorMessage = message;
                }
            } else if (error.message) {
                errorMessage = error.message;
            }
 
            Alert({
                header: "Error",
                message: errorMessage,
                buttons: [
                    {
                        text: "OK",
                        handler: () => {
                            if (error.response?.status === 409) {
                                window.location.reload();
                            }
                        }
                    }
                ]
            });
        }
    };
 
    const headerColumns = useMemo(() => [
        {
            name: '',
            cell: (row: RowType) => (
                <IonCheckbox
                    checked={row.isSelected || false}
                    onIonChange={() => handlingRowSelect(row)}
                    style={{ cursor: 'pointer' }}
                />
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            width: '50px',
        },
        {
            name: "Booking Order Number",
            selector: (row: RowType) => row.BookingOrderNumber,
            sortable: true,
            width: "200px",
        },
        {
            name: "First Name",
            selector: (row: RowType) => row.FirstName || "N/A",
            sortable: true,
            width: "220px",
        },
        {
            name: "Total Amount",
            selector: (row: RowType) => row.TotalAmount,
            sortable: true,
            width: "150px",
        },
        {
            name: "Disbursement Number",
            selector: (row: RowType) => row.DisbursementNumber,
            sortable: true,
            width: "150px",
        },
        {
            name: "Payment Order Number",
            cell: (row: RowType) => (
                <OptimizedInput
                    value={row.editablePaymentOrderNo || ""}
                    bookingOrderNumber={row.BookingOrderNumber}
                    field="PaymentOrderNo"
                />
            ),
            width: "200px",
            ignoreRowClick: true,
        },
        {
            name: "Fund Ref1",
            cell: (row: RowType) => (
                <OptimizedInput
                    value={row.editableFundRef1 || ""}
                    bookingOrderNumber={row.BookingOrderNumber}
                    field="FundRef1"
                />
            ),
            width: "200px",
            ignoreRowClick: true,
        },
        {
            name: "Fund Ref2",
            cell: (row: RowType) => (
                <OptimizedInput
                    value={row.editableFundRef2 || ""}
                    bookingOrderNumber={row.BookingOrderNumber}
                    field="FundRef2"
                />
            ),
            width: "200px",
            ignoreRowClick: true,
        },
    ], [OptimizedInput, handlingRowSelect]);
 
    const detailColumns = useMemo(() => [
        {
            name: 'Fund Category',
            selector: (row: RowType) => row.FundCategory || 'N/A',
        },
        {
            name: 'Pooja Code',
            selector: (row: RowType) => row.PoojaCode || 'N/A',
        },
        {
            name: 'Fund ID',
            selector: (row: RowType) => row.FundId || 'N/A',
        },
        {
            name: 'Booking Detail Number',
            selector: (row: RowType) => row.BookingDetailNumber || 'N/A',
        },
        {
            name: 'Amount',
            selector: (row: RowType) => row.TotalAmount || 'N/A',
            right: true,
        },
    ], []);
 
    const ExpandedComponent = ({ data }: { data: RowType }) => (
        <DataTable
            columns={detailColumns}
            data={data.details || []}
            noHeader
            pagination={false}
        />
    );
 
    const conditionalRowStyles = [
        {
            when: (row: RowType) => {
                const filledCount = [
                    row.editablePaymentOrderNo,
                    row.editableFundRef1,
                    row.editableFundRef2
                ].filter(val => val && val.trim() !== '').length;
                return filledCount >= 1;
            },
            style: {
                background: "#bbffbb",
                borderTop: '1px solid rgba(0,0,0,0.1)',
                borderBottom: '1px solid rgba(0,0,0,0.1)',
            },
        },
    ];
 
    const exportData = () => {
        const headers = [
            { name: 'FundCategory' },
            { name: 'PoojaCode' },
            { name: 'OrderedBy' },
            { name: 'FirstName' },
            { name: 'FundId' },
            { name: 'BookingDetailNumber' },
            { name: 'TotalAmount' },
            { name: 'BookingOrderNumber' },
        ];
 
        const groupedData = actualData.reduce((acc: Record<string, RowType[]>, row: RowType) => {
            if (!acc[row.BookingOrderNumber]) {
                acc[row.BookingOrderNumber] = [];
            }
            acc[row.BookingOrderNumber].push(row);
            return acc;
        }, {});
 
        const preparedData = Object.values(groupedData).flatMap(group => {
            const mainRow = group[0];
            const exportRows = [{
                ...mainRow,
                isMainRow: true
            }];
 
            if (group.length > 1) {
                exportRows.push(...group.slice(1).map(row => ({
                    ...row,
                    isMainRow: false
                })));
            }
 
            return exportRows;
        });
 
        exportCSV(headers, preparedData, "Fund Report");
    };
 
    const subHeaderComponent = useMemo(() => {
        return (
            <IonRow className="table_btn_container">
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <IonButton className="admin_add_btn" onClick={exportData}>
                        Export
                    </IonButton>
                    <IonButton className="admin_add_btn" onClick={handleSubmit}>
                        Submit
                    </IonButton>
                    <IonSearchbar
                        value={filterText}
                        onIonChange={(e: any) => setFilterText(e.detail.value)}
                        placeholder="Search"
                        className="table_search"
                    />
                </div>
            </IonRow>
        );
    }, [filterText, exportData, handleSubmit]);
 
    const handleRowClicks = (row: RowType) => {
        setExpandedRows(prev => ({
            ...prev,
            [row.BookingOrderNumber]: !prev[row.BookingOrderNumber]
        }));
    };
 
    return (
        <IonPage>
            {userRole === "ROLE_ADMIN" && <>
                <AdminHead User={"user"} Role={"Role"} Name={"Fund Disbursed"} />
                <Sidebar /></>}
            <IonContent>
                <IonLoading message="Loading..." spinner={null} isOpen={showLoading} />
                {userRole !== "ROLE_ADMIN" && <HeadFoot User={"login"} Role="Role" Name='Home,Fund Disbursed' />}
                <IonGrid className={userRole === "ROLE_ADMIN" ? "page-wrapper report_container_middle" : "page_content_padding tableContainev2"}>
                    <CommonDataTable
                        columns={headerColumns}
                        expandableRows={true}
                        data={tableData}
                        defaultSortFieldId="name"
                        striped
                        noDataComponent="Sorry ! No result found"
                        isSubHeader={true}
                        subHeaderComponent={subHeaderComponent}
                        expandableRowsComponent={ExpandedComponent}
                        onRowClick={handleRowClicks}
                        expandedRows={(row: RowType) => !!expandedRows[row.BookingOrderNumber]}
                        selectableRows={false}
                        conditionalRowStyles={conditionalRowStyles}
                        customStyles={{
                            rows: {
                                style: {
                                    borderBottom: '1px solid #e0e0e0',
                                },
                            },
                        }}
                    />
                </IonGrid>
                <CommonModal
                    showModal={Commonmodal}
                    closeModal={modalClose}
                    modaltitle={Commmonmodaltitle}
                    AlertModalMesg={CommonModalMesg}
                />
            </IonContent>
        </IonPage>
    );
};
 
export default FundDisbursed;
 